import React, { useEffect } from 'react'
import { useOutletContext } from 'react-router';
import { CampaignOutletContextValue } from '../form';
import { Accordion, AccordionDetails, AccordionSummary, Checkbox, FormControlLabel } from "@mui/material";
import { FileInput, FileInputType } from '../../../components/file-input';

export default function EPOS() {
    const { setValue, values, onChange, errors, loading, readOnly, setTab } = useOutletContext<CampaignOutletContextValue>();

    useEffect(() => {
        setTab('epos');
    }, []);

    const field = {
        onChange: onChange,
        setValue: setValue,
        readOnly: readOnly
    };

    return (
        <React.Fragment>
            <Accordion defaultExpanded={true}>
                <AccordionSummary>Artwork Status</AccordionSummary>
                <AccordionDetails>
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="epos_artwork_reviewed"
                                checked={!!values.epos_artwork_reviewed}
                                disabled={readOnly}
                                {...field}
                            />
                        }
                        label="Artwork Reviewed / Submitted"
                    />
                </AccordionDetails>
            </Accordion>

            <Accordion defaultExpanded={true}>
                <AccordionSummary>POPS (Proof Of Postings)</AccordionSummary>
                <AccordionDetails>
                    <FileInput showPreview={true} type={FileInputType.File} multiple={true}
                        maxThumbSize={320} label="Select any relevant File(s)"
                        name="popsFiles" showList={true}
                        allowDelete={true}
                        fileType="POPS" value={values.popsFiles}
                        {...field}
                    />
                </AccordionDetails>
            </Accordion>
        </React.Fragment>
    )
}
